var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 58,
    viewBox: "0 0 51 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.87842 18.6216C6.87842 28.8635 15.2581 37.2432 25.5 37.2432C35.7419 37.2432 44.1216 28.8635 44.1216 18.6216C44.1216 8.37972 35.7419 0 25.5 0C15.2581 0 6.87842 8.37972 6.87842 18.6216ZM39.7401 18.6216C39.7401 26.4536 33.332 32.8616 25.5 32.8616C17.668 32.8616 11.26 26.4536 11.26 18.6216C11.26 10.7896 17.668 4.38155 25.5 4.38155C33.332 4.38155 39.7401 10.7896 39.7401 18.6216Z",
    fill: "#7363F8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.81131 57.2484C9.61687 51.4429 17.2846 48.2663 25.5 48.2663C33.7154 48.2663 41.3831 51.4429 47.1887 57.2484L50.3105 54.1266C43.6834 47.5543 34.8656 43.8847 25.5 43.8847C16.1344 43.8847 7.31655 47.5543 0.689453 54.1266L3.81131 57.2484Z",
    fill: "#7363F8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.0eae96bceda5008eef447a037b558eb1.svg";
export { ForwardRef as ReactComponent };